import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
// import UsersListLayer from "../components/UsersListLayer";
import SubscriberPageLayer from "../components/SubscriberPageLayer";


const UsersListPage = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Subscriber" header="Our Subscribers" />

        {/* UsersListLayer */}
        <SubscriberPageLayer />

      </MasterLayout>

    </>
  );
};

export default UsersListPage; 
